<template>
  <div id="annualReportInc">
    <a-form
      ref="step6Ref"
      class="ant-round-form material-annual-report-inc-form"
      layout="vertical"
      :model="modelForm"
      :rules="rules"
      @finish="submit"
    >

      <a-form-item v-if="countryCode === 'HK'" name="nar1Path1" :label="$t('pages_merchant_050')">
        <div class="explain" style="margin-bottom: 24px">
          <span>{{ $t('pages_merchant_052') }}</span>
        </div>
        <upload-auto
          ref="uploadRRef"
          v-model:file-content="modelForm.nar1Path1"
          accept=".jpg,.jpeg,.png,.pdf,.bmp"
          type="INVITE"
          list-type="picture"
          back-type="array"
          :disabled="modelForm.nar1Path1Disabled"
          :explain="$t('pages_merchant_032')"
          :max-count="5"
        />
        <div v-if="!modelForm.nar1Path1Disabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.nar1Path1Message }}</span>
        </div>
      </a-form-item>

      <a-form-item v-if="['KY', 'VG', 'SC','HK'].includes(countryCode)" name="nnc1Path" :label="countryCode === 'HK'?$t('pages_merchant_051'):$t('pages_merchant_034')">
        <div v-if="!['KY','VG','SC'].includes(countryCode)" class="explain" style="margin-bottom: 24px">
          <span>{{ $t('pages_merchant_211') }}</span>
          <a style="color:#BA8438;" :href="require('/src/assets/files/faTuanChengLiBiao.png')" target="_blank">{{ $t('pages_merchant_051') }}</a>
          <span>{{ $t('pages_merchant_212') }}</span>
        </div>
        <div v-else class="explain" style="margin-bottom: 24px">
          <span>{{ $t('pages_merchant_035') }}</span>
          <a style="color:#BA8438;" :href="require('/src/assets/files/kaiMan.png')" target="_blank">{{ $t('pages_merchant_036') }}</a>
          /
          <a style="color:#BA8438;" :href="require('/src/assets/files/weiJingQunDao.png')" target="_blank">{{ $t('pages_merchant_037') }}</a> /
          <a style="color:#BA8438;" :href="require('/src/assets/files/incumbency.png')" target="_blank">{{ $t('pages_merchant_038') }}</a>
          <span>{{ $t('pages_merchant_039') }}</span>
        </div>
        <upload-auto
          ref="uploadCRef"
          v-model:file-content="modelForm.nnc1Path"
          accept=".jpg,.jpeg,.png,.pdf,.bmp"
          type="INVITE"
          list-type="picture"
          back-type="array"
          :disabled="modelForm.nnc1PathDisabled"
          :explain="$t('pages_merchant_032')"
          :max-count="5"
        />
        <div v-if="!modelForm.nnc1PathDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.nnc1PathMessage }}</span>
        </div>
      </a-form-item>
      <!-- 良好存续证明 -->
      <a-form-item v-else name="goodstandPath" :label="$t('pages_merchant_201')">
        <div class="explain" style="margin-bottom: 24px">
          <span>{{ $t('pages_merchant_202') }}</span>
        </div>
        <upload-auto
          ref="uploadGRef"
          v-model:file-content="modelForm.goodstandPath"
          accept=".jpg,.jpeg,.png,.pdf,.bmp"
          type="INVITE"
          list-type="picture"
          back-type="array"
          :disabled="modelForm.goodstandPathDisabled"
          :explain="$t('pages_merchant_032')"
          :max-count="5"
        />
        <div v-if="!modelForm.goodstandPathDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.goodstandPathMessage }}</span>
        </div>
      </a-form-item>
      <a-form-item style="text-align: right; margin-top: 48px">
        <a-button
          type="primary"
          shape="round"
          ghost
          style="min-width: 138px; margin-right: 24px"
          @click="$emit('next', '2-2')"
        >{{ $t('pages_merchant_040') }}</a-button>
        <a-button
          html-type="submit"
          type="primary"
          shape="round"
          style="min-width: 138px"
        >{{ $t('pages_merchant_020') }}</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import { ref, reactive, toRefs, computed, nextTick } from 'vue'
import UploadAuto from '@/components/upload-auto'
import i18n from '@/locale'
export default {
  name: 'AnnualReportInc',
  components: {
    'upload-auto': UploadAuto
  },
  props: {
    model: {
      type: Object,
      default: () => { return {} }
    },
    refused: {
      type: Boolean,
      default: () => { return false }
    },
    countryCode: {
      type: String,
      default: () => { return '' }
    },
    parentsModel: {
      type: Object,
      default: () => { return {} }
    }
  },
  setup (props, ctx) {
    const step6Ref = ref(null)
    const uploadRRef = ref(null)
    const uploadCRef = ref(null)
    const uploadGRef = ref(null)

    const state = reactive({
      rules: {
        nnc1Path: [{ required: true, message: i18n.global.t('common_text_007') + (props.countryCode === 'HK' ? i18n.global.t('pages_merchant_053') : i18n.global.t('pages_merchant_203')) }],
        goodstandPath: [{ required: true, message: i18n.global.t('common_text_007') + i18n.global.t('pages_merchant_201') }]
      }
    })
    state.parentsModelForm = computed(() => {
      return props.parentsModel
    })
    state.modelForm = computed(() => {
      return props.model
    })

    const submit = () => {
      ctx.emit('next', '2-4')
    }

    nextTick(() => {
      if (uploadRRef.value && state.modelForm.nar1Path1.length !== 0) uploadRRef.value.fileListRefresh(state.modelForm.nar1Path1)
      if (uploadCRef.value && state.modelForm.nnc1Path.length !== 0) uploadCRef.value.fileListRefresh(state.modelForm.nnc1Path)
      if (uploadGRef.value && state.modelForm.goodstandPath.length !== 0) uploadGRef.value.fileListRefresh(state.modelForm.goodstandPath)
    })
    const loadPath = () => {
      if (['KY', 'VG', 'SC'].includes(props.countryCode) && state.parentsModelForm.radioShow === '1') {
        nextTick(() => {
          const { parentCertificatePath } = state.parentsModelForm
          if (parentCertificatePath.length !== 0 && uploadCRef.value) {
            uploadCRef.value.fileListRefresh(parentCertificatePath)
            state.modelForm.nnc1Path = parentCertificatePath
          }
        })
      }
    }

    loadPath()
    return {
      step6Ref,
      uploadRRef,
      uploadCRef,
      uploadGRef,
      submit,
      ...toRefs(state)
    }
  }
}
</script>
<style lang="less" scoped>
#annualReportInc {
  .material-annual-report-inc-form {
    .explain {
      color: #495060;
    }
  }
}

</style>

